<template style="align-items: center">
  <v-container class="setPwdOverlay">
    <template>
      <div class="dialog" v-if="pwdChanged == false" v-hide="pwdChanged">
        <form action="" method="post" name="signupForm" id="signupForm">
          <img src="" id="signupLogo" />

          <h1 class="formTitle">Set New Password</h1>

          <v-flex
            xs12
            sm12
            md12
            mt-2
            style="margin-bottom: 2px !important; margin-left: 14%"
          >
            <div class="small-input" style="width: 80%">
              <label class="grey--text text--darken-2">
                <p dir="auto" style="margin-bottom: 7px; font-family: Arial">
                  New Password
                </p>
              </label>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, newPassword }">
                  <div style="position: relative; width: 100%">
                    <input
                      v-bind="newPassword"
                      v-on="on"
                      :type="showPassword ? 'text' : 'password'"
                      :class="{ 'error-border': newPwdErrorMsg.length > 0 }"
                      placeholder="New Password"
                      maxlength="20"
                      v-model="newPwd"
                      @input="newPwdValidate(newPwd)"
                      @blur="validateNewPwd"
                      autocomplete="off"
                      style="
                        width: 100%;
                        padding: 10px;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                      "
                    />

                    <a
                      @click="pwdShowHide"
                      class="position-absolute"
                      style="
                        position: absolute;
                        top: 50%;
                        right: 10px;
                        transform: translateY(-50%);
                        cursor: pointer;
                      "
                    >
                      <img
                        v-if="showPassword"
                        width="24"
                        height="24"
                        :src="showPwdIco"
                        alt="Show password"
                      />
                      <img
                        v-else
                        width="24"
                        height="24"
                        :src="hidePwdIco"
                        alt="Hide password"
                      />
                    </a>
                  </div>
                </template>
                <span>
                  <p>
                    Password must be at least 8 characters long. A combination
                    of <br />uppercase letters, lowercase letters, numbers, and
                    special characters.
                  </p>
                </span>
              </v-tooltip>
              <div
                style="color: red; text-align: left; padding-bottom: 2px"
                v-if="newPwdErrorMsg.length > 0"
              >
                {{ newPwdErrorMsg }}
              </div>
            </div>
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
            mt-2
            style="margin-bottom: 2px !important; margin-left: 14%"
          >
            <div class="small-input" style="width: 80%">
              <label class="grey--text text--darken-2">
                <p dir="auto" style="margin-bottom: 7px; font-family: Arial">
                  Confirm Password
                </p>
              </label>
              <!-- <v-text-field full-width class="mt-2 mb-0 textFieldCursorAlign" type="password" transition="slide-x-transition" id="" aria-placeholder="Enter current password" maxLength="20" solo v-model="confirmPwd" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showConfirmPassword ? 'text' : 'password'" @click:append="showConfirmPassword = !showConfirmPassword">
             </v-text-field> -->

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div style="position: relative; width: 100%">
                    <input
                      v-bind="attrs"
                      v-on="on"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :class="{ 'error-border': confirmPwdErrorMsg.length > 0 }"
                      placeholder="Confirm Password"
                      maxlength="20"
                      v-model="confirmPwd"
                      @input="confirmPwdValidate(confirmPwd)"
                      @blur="validateConfirmPwd"
                      autocomplete="off"
                      style="
                        width: 100%;
                        padding: 10px;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                      "
                    />
                    <a
                      @click="confirmPwdShowHide"
                      class="position-absolute"
                      style="
                        position: absolute;
                        top: 50%;
                        right: 10px;
                        transform: translateY(-50%);
                        cursor: pointer;
                      "
                    >
                      <img
                        v-if="showConfirmPassword"
                        width="24"
                        height="24"
                        :src="showPwdIco"
                        alt="Show password"
                      />
                      <img
                        v-else
                        width="24"
                        height="24"
                        :src="hidePwdIco"
                        alt="Hide password"
                      />
                    </a>
                  </div>
                </template>
                <span>
                  <p>
                    Password must be at least 8 characters long. A combination
                    of <br />uppercase letters, lowercase letters, numbers, and
                    special characters.
                  </p>
                </span>
              </v-tooltip>

              <div
                style="color: red; text-align: left; padding-bottom: 2px"
                v-if="confirmPwdErrorMsg.length > 0"
              >
                {{ confirmPwdErrorMsg }}
              </div>
            </div>
          </v-flex>

          <v-flex>
            <v-layout row justify-center>
              <v-flex>
                <v-btn
                  color="primary-btn"
                  style="font-size: 18px"
                  dark
                  block
                  class="text-none"
                  v-on:click="
                    PreLoader = true;
                    set_password();
                  "
                  >Change Password</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </form>
      </div>
      <!-- Password changed success message -->
      <div
        class="updatedPwdCardStyle updatedPwdPopUp"
        persistent
        style="text-align: center"
        v-if="pwdChanged == true"
        v-hide="!pwdChanged"
      >
        <img style="width: 40px" :src="successIconSrc" />
        <p style="font-size: 20px" class="pwdUpdatedStyle"><b>Success </b></p>
        <br />
        <b style="font-size: 14px">{{ pwdUpdateStatusmsg }}</b
        ><br />
        <b style="font-size: 14px"
          >Kindly click on OK button to login using your updated password</b
        >

        <div class="buttonWrapper">
          <button
            type="submit"
            v-on:click="(PreLoader = true), forgotPasswordUpdated()"
            class="submitButton pure-button pure-button-primary"
          >
            <span>OK</span>
          </button>
        </div>
      </div>

      <!-- Error Pop up -->

      <!-- Change password pop up  -->
      <!-- <v-card class="modal-backdrop cards procDiv container hide" ref="modal" id="ChangePwdModalModal" data-keyboard="false" data-backdrop="static" v-show="currentPwdError">
   <div class="modal" style="overflow-y: auto; border-radius: 15px; padding: 5px; width: 40%;height: max-content; border-radius: 15px;padding: 5px;">
        
      <div class="facingPage">
                  <h4 class="grey--text text--darken-2 mb-0 mt-1" style="text-align: center; padding-bottom: 5%;color: red !important; border-bottom: 1px solid lightgrey;" >Alert!</h4>
                  <p class="grey--text text--darken-2 mb-0 mt-1" id="proc_message" style="text-align: center;padding-bottom: 5%;color: black !important; padding-top: 10px;">
                     {{ pwdUpdateStatusmsg }}
                  </p>
                  <v-flex style="border-top: none !important; align-self: center;" class="text-align-center padding-bottom-5" >
                      <v-layout class="text-align-center padding-bottom-5" >
                          <v-flex class="text-align-center padding-bottom-5" style="display: -webkit-inline-box; -webkit-box-pack: center;">
                              <v-btn class="text-align-center padding-bottom-5 text-none" color="primary-btn" @click="returnToChangePasswordPage()" dark block >Re-enter the current Password</v-btn>
                          </v-flex>
                      </v-layout>
                  </v-flex>
              </div>
  </div>
  </v-card> -->
    </template>

    <!--Preloader starts-->
    <div
      class="pre-loader"
      v-show="PreLoader == true"
      v-hide="PreLoader == false"
    >
      <img :src="preLoaderImg" />
    </div>

    <!--Preloader ends-->
  </v-container>
</template>

<style lang="css" scoped>
.setPwdOverlay {
  /* position: fixed;  */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.5);  */
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog {
  background: white; /* Dialog background color */
  padding: 20px;
  border-radius: 5px;
  max-width: 90%;
  max-height: 90%;
  /* overflow: auto;  */
  width: 50%;
}

@media screen and (max-width: 896px) {
  .dialog {
    width: 100% !important;
  }
}

.layout.row {
  flex-direction: row !important;
  width: 99% !important;
  margin: auto !important;
}

.lockStyle {
  /* transform: translate(179%, -32px); */
  height: 135px;
  margin-top: 5%;
}
.pwdUpdatedStyle {
  font-size: 20px;
}
.LabelStyle {
  margin-bottom: 7px;
  font-family: "Arial";
  text-align: left;
  font-weight: bold;
}
.changePwdPopUp {
  padding-bottom: 8px !important;
  transform: translate(10%, 51%) !important;
  /* width: 26rem; */
}
.updatedPwdPopUp {
  padding-bottom: 8px !important;
}
.row {
  display: flex;
  padding: 10px;
  width: 100%;
  align-items: center;
  /* background-color: #d3d3d373; */
  background-color: white;
}
.col-lg-6 {
  padding: 20px;
  width: 98%;
  justify-content: center;
  text-align: center;
  border-radius: 15px;
}
.mainDiv {
  display: flex;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  font-family: "Open Sans", sans-serif;
}
.cardStyle {
  width: 70%;
  border-color: white;
  background: #fff;
  /* padding: 36px 0; */
  border-radius: 15px;
  /* margin: 30px 0; */
  /* box-shadow: 0px 0 2px 0 rgba(0,0,0,0.25); */
  /* transform: translate(50%,8%); */
}
.updatedPwdCardStyle {
  /* width: 50%; */
  border-color: white;
  background: #fff;
  padding: 36px 0;
  border-radius: 15px;
  /* margin: 30px 0; */
  box-shadow: 0px 0 2px 0 rgba(0, 0, 0, 0.25);
  /* transform: translate(50%,8%); */
  max-width: max-content;
  padding: 15px;
}
#signupLogo {
  max-height: 100px;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.formTitle {
  font-weight: 600;
  margin-top: 2%;
  color: #2f2d3b;
  text-align: center;
  font-size: 28px;
  margin-bottom: 5%;
}
.inputLabel {
  font-size: 14px;
  color: #555;
  margin-bottom: 6px;
  margin-top: 24px;
}
.inputDiv {
  width: 70%;
  display: flex;
  flex-direction: column;
  margin: auto;
}
/* input {
    height: 40px;
    font-size: 16px;
    border-radius: 4px;
    border: none;
    border: solid 1px #ccc;
    padding: 0 11px;
  } */
input:disabled {
  cursor: not-allowed;
  border: solid 1px #eee;
}
.buttonWrapper {
  margin-top: 40px;
}
.submitButton {
  width: 70%;
  height: 40px;
  margin: auto;
  margin-bottom: 5%;
  display: block;
  color: #fff;
  background-color: #003883;
  border-color: #003883;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.035);
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
}
.submitButton:disabled,
button[disabled] {
  border: 1px solid #cccccc;
  background-color: #cccccc;
  color: #666666;
}

#loader {
  position: absolute;
  z-index: 1;
  margin: -2px 0 0 10px;
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #666666;
  width: 14px;
  height: 14px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  /* inset: auto !important; */
}

.modal {
  background: #ffffff;
  /* box-shadow: 0px 0px 4px 1px; */
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 50%;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 959px) {
  .changePwdPopUp {
    /* padding-bottom: 8px !important; 
      width: 98% !important;
      position: absolute; */
    padding-bottom: 8px !important;
    width: 98% !important;
    position: relative;
    /* transform: translate(-1.2%, -47%) !important; */
    transform: translate(-1%, 40%) !important;
  }
  .updatedPwdPopUp {
    padding-bottom: 8px !important;
    width: 50% !important;
    position: absolute;
    /* transform: translate(5%, 50%) !important; */
    /* transform: translate(47.8%, -41%) !important; */
  }
}
/* @media screen and(min-width: 390px) {
    .changePwdPopUp{
      padding-bottom: 8px !important;
      width: 100% !important;
      position: absolute;
      transform: translate(-1%, -47%);
  }
  } */
@media screen and (max-width: 414px) {
  .changePwdPopUp {
    padding-bottom: 8px !important;
    width: 100% !important;
    position: absolute;
    transform: translate(-3%, -46%) !important;
  }
  .updatedPwdPopUp {
    position: absolute;
    /* transform: translate(-4.2%, -41%) !important; */
    padding: 2%;
    width: 100% !important;
  }
  .lockStyle {
    /* transform: translate(87%, -10px) !important; */
    height: 135px !important;
    margin-top: 5% !important;
  }
}
</style>

<script type="text/javascript">
import router from "@/router";
import { db, externalURL } from "@/sunidhiapp";
import $ from "jquery";
import loader from "@/assets/images/Preloader.gif";
import showPwdImgSrc from "@/assets/images/eye view.svg";
import hidePwdImgSrc from "@/assets/images/eye hide.svg";
import successIcon from "@/assets/images/GreenTickIcon.svg";

export default {
  name: "setNewPassword",
  data: function () {
    return {
      newPwd: "",
      confirmPwd: "",
      pwdChanged: false,
      pwdUpdateStatusmsg: "",
      currentPwdErrorMsg: "",
      newPwdErrorMsg: "",
      confirmPwdErrorMsg: "",
      PreLoader: false,
      showPassword: false,
      showConfirmPassword: false,
      PwdError: false,
      preLoaderImg: loader,
      hidePwdIco: hidePwdImgSrc,
      showPwdIco: showPwdImgSrc,
      successIconSrc: successIcon,
    };
  },
  mounted: async function () {},
  methods: {
    async pwdShowHide() {
      // debugger
      var self = this;

      self.showPassword = !self.showPassword;
    },
    async confirmPwdShowHide() {
      // debugger
      var self = this;

      self.showConfirmPassword = !self.showConfirmPassword;
    },

    newPwdValidate(newPwdValue) {
      var self = this;
      if (newPwdValue.length <= 0) {
        self.newPwdErrorMsg = "Enter the new password";
      } else if (newPwdValue.length > 0) {
        var regex =
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
        if (self.newPwd == self.currentPwd) {
          self.newPwdErrorMsg =
            "Your new password should not be same as the current password";
        } else if (!regex.test(newPwdValue)) {
          self.newPwdErrorMsg = "Password does not match the criteria";
        } else {
          self.newPwdErrorMsg = "";
        }
      }
    },

    confirmPwdValidate(confirmPwdValue) {
      var self = this;
      if (confirmPwdValue.length <= 0) {
        self.confirmPwdErrorMsg = "Confirm the password";
      } else if (confirmPwdValue.length > 0) {
        if (confirmPwdValue != self.newPwd) {
          self.confirmPwdErrorMsg =
            "New Password and confirmation password must match";
        } else self.confirmPwdErrorMsg = "";
      }
    },

    validateNewPwd() {
      if (!this.newPwd) {
        this.newPwdErrorMsg = "New Password is required.";
      } else {
        this.newPwdErrorMsg = "";
      }
    },
    validateConfirmPwd() {
      if (!this.confirmPwd) {
        this.confirmPwdErrorMsg = "Confirm Password is required.";
      } else {
        this.confirmPwdErrorMsg = "";
      }
    },
    async set_password() {
      var self = this;
      self.PreLoader = true;
      self.PwdErrorMsg = "";
      self.newPwdErrorMsg = "";
      self.confirmPwdErrorMsg = "";

      var vaerror = 0;
      if (self.newPwd.length <= 0) {
        self.newPwdErrorMsg = "Enter New Password";
        vaerror = 1;
      } else if (self.newPwd.length > 0) {
        var regex =
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
        var pwdValue = self.newPwd;
        if (!regex.test(pwdValue)) {
          self.newPwdErrorMsg = "Password does not match the criteria";
          vaerror = 1;
        }
      }
      if (self.confirmPwd.length <= 0) {
        self.confirmPwdErrorMsg = "Enter Confirm Password";
        vaerror = 1;
      } else if (self.confirmPwd.length > 0) {
        if (pwdValue != self.confirmPwd) {
          self.confirmPwdErrorMsg =
            "New Password and confirmation password must match";
          vaerror = 1;
        }
      }

      if (vaerror == 1) {
        setTimeout(() => {
          self.PreLoader = false;
        }, 500);
        return;
      } else {
        self.PreLoader = true;
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

        if (genzdata != null && genzdata.length > 0) {
          var trimSpaceUserID = genzdata[0].DSAUserId;
          trimSpaceUserID.trimEnd();
          await db.TbGenz.update(genzdata[0].PkId, {
            loginType: genzdata[0].loginType,
            DSAUserId: trimSpaceUserID,
          });
        }
        // else {
        //     await db.TbGenz.put({ UserId: 1,loginType :loginType, DSAUserId: ForgotPwdDSAUserIDDecrypted});
        //     genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        // }

        var object = new Object();
        (object.newPwd = await this.$sunidhi.encryptValue(
          self.newPwd,
          this.$sunidhi.keyValue
        )),
          (object.ForgotPwdDSAUserIDEncrypted =
            await this.$sunidhi.encryptValue(
              genzdata[0].DSAUserId,
              this.$sunidhi.keyValue
            )),
          $.ajax({
            url: externalURL + "ChangePWAUserPassword/",
            type: "POST",
            headers: {
              PWAUserId: object.ForgotPwdDSAUserIDEncrypted,
              PWAUserNewPassword: object.newPwd,
              PwaUserType: this.$sunidhi.PwaUserType,
              // "PWAUserSessionId" : genzdata[0].PWAUserSessionId
            },
            responseType: "application/text",
            success: async function (data) {
              console.log("ChangePWAUserPassword", data);
              if (data) {
                if (data.DSAAuthenticationStatus !== "01") {


                  if (data.PasswordUpdateStatus) {
                    switch (data.PasswordUpdateStatus) {
                      case "00": //Success
                        self.pwdUpdateStatusmsg =
                          data.PasswordUpdateStatusMessage;
                        self.pwdChanged = true;
                        setTimeout(() => {
                          self.PreLoader = false;
                        }, 500);
                        break;

                      case "97":
                        self.newPwdErrorMsg = data.PasswordUpdateStatusMessage;
                        setTimeout(() => {
                          self.PreLoader = false;
                        }, 500);
                        return;
                    }
                  }
                } else {
                  alert(data.message);
                  setTimeout(() => {
                    self.PreLoader = false;
                  }, 500);
                }
              }
            },
            error: function (ex) {
              setTimeout(() => {
                this.PreLoader = false;
              }, 500);
              alert(ex.responseJSON.message);
            },
          });
      }
    },

    async forgotPasswordUpdated() {
      var self = this;
      //   await deleteDBData();
      setTimeout(() => {
        self.PreLoader = false;
      }, 500);
      this.$sunidhi.logoutBtnDisp = "false";
      router.push({ name: "LoginPage" });
      // window.location.reload(true);
    },
  },
};
</script>
